import React, { memo } from 'react';

import { Tabs } from '@mui/material';
import PropTypes from 'prop-types';

import TabCDS from './TabCDS';
import { TabsStyle } from './TabsCDS.constants';
import { getTabsStyles } from './TabsCDS.styles';

const TabsCDS = ({
  value,
  onChange,
  tabs,
  variant = 'standard',
  tabsStyle = TabsStyle.ON_CARD,
  className = '',
  testId = 'tabs-cds',
  ...restProps
}) => {
  return (
    <Tabs
      className={className}
      data-testid={testId}
      sx={getTabsStyles(tabsStyle)}
      textColor="inherit"
      value={value}
      variant={variant}
      onChange={onChange}
      {...restProps}
    >
      {tabs.map(
        (
          { label, value: tabValue, count, icon, disabled, additionalLabelProps, checked },
          index,
        ) => (
          <TabCDS
            checked={checked}
            count={count}
            disabled={disabled}
            key={tabValue ?? index}
            labelProps={additionalLabelProps}
            tabIcon={icon}
            title={label}
            value={tabValue ?? index}
          />
        ),
      )}
    </Tabs>
  );
};

TabsCDS.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      count: PropTypes.number,
      icon: PropTypes.elementType,
      disabled: PropTypes.bool,
      checked: PropTypes.bool,
      additionalLabelProps: PropTypes.shape({
        title: PropTypes.string,
        variant: PropTypes.string,
        size: PropTypes.string,
      }),
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['standard', 'scrollable', 'fullWidth']),
  tabsStyle: PropTypes.oneOf([TabsStyle.ON_CARD, TabsStyle.ON_PAGE]),
  className: PropTypes.string,
  testId: PropTypes.string,
};

export default memo(TabsCDS);
